import { motion } from 'framer-motion';

// Splits a string into lines by word wrapping is complex; here we accept an array of lines
// Each line is wrapped in an overflow-hidden container and animated upward.
export const MaskedReveal = ({ lines = [], delay = 0, stagger = 0.09, className = '', textClass = '' }) => {
    return (
        <div className={className}>
            {lines.map((line, i) => (
                <div key={i} className="line-mask block w-full">
                    <motion.span
                        initial={{ y: '110%' }}
                        animate={{ y: '0%' }}
                        transition={{
                            duration: 0.95,
                            delay: delay + i * stagger,
                            ease: [0.77, 0, 0.175, 1],
                        }}
                        className={`block ${textClass}`}
                    >
                        {line}
                    </motion.span>
                </div>
            ))}
        </div>
    );
};

export const MaskedRevealOnView = ({ lines = [], className = '', textClass = '', stagger = 0.08 }) => (
    <div className={className}>
        {lines.map((line, i) => (
            <div key={i} className="line-mask block w-full">
                <motion.span
                    initial={{ y: '110%' }}
                    whileInView={{ y: '0%' }}
                    viewport={{ once: true, margin: '-80px' }}
                    transition={{ duration: 0.9, delay: i * stagger, ease: [0.77, 0, 0.175, 1] }}
                    className={`block ${textClass}`}
                >
                    {line}
                </motion.span>
            </div>
        ))}
    </div>
);

export const FadeUp = ({ children, delay = 0, className = '' }) => (
    <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);
